import styles from './Carousel.module.scss';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Carousel = (props) => {

  useEffect(() => {
    AOS.init({duration: 1000});
  }, []);

  return (
    <>
      {props.language === 'pl' &&
        <h1 data-aos="fade-down" className={styles.label}>Rekomendują nas:</h1>
      }
      {props.language === 'eng' &&
        <h1 data-aos="fade-down" className={styles.label}>We are recommended by:</h1>
      }
      <div className={styles.lines} data-aos="fade-left">
        <div className={styles.FirstLine}></div>
        <div className={styles.SecondLine}></div>
        <div className={styles.ThirdLine}></div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/zielen.png`}></img>
          <p className={styles.imgLabel}>Zieleń sp. z o.o.</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/suca.png`}></img>
          <p className={styles.imgLabel}>Suca Pizza & Kebab Rumia</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/wolfmoon.png`}></img>
          <p className={styles.imgLabel}>Wolf Moon sp. z o.o.</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/europrofit.jpg`}></img>
          <p className={styles.imgLabel}>Europrofit Konstrukcje Stalowe sp. z o.o.</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/domnakaszubach.jpg`}></img>
          <p className={styles.imgLabel}>Dom-na-kaszubach.pl</p>
        </div>
        <div className={styles.inner}>
          <p className={styles.imgLabel}>Adiro Firma Handlowo-Usługowa Robert Ciura</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/kevin.png`}></img>
          <p className={styles.imgLabel}>Kevin Dubieński Gdynia</p>
        </div>
        <div className={styles.inner}>
          <p className={styles.imgLabel}>Lg Profi Leszek Gontarz</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/joa.png`}></img>
          <p className={styles.imgLabel}>Joa.com.pl</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/ss.png`}></img>
          <p className={styles.imgLabel}>Sławomir Sawicki Nieruchomości</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/zulawskiesmaki.png`}></img>
          <p className={styles.imgLabel}>Żuławskie smaki</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/zulawskiepierogi.jpg`}></img>
          <p className={styles.imgLabel}>Żuławskie pierogi</p>
        </div>
        <div className={styles.inner}>
          <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/companies/1001opon.jpg`}></img>
          <p className={styles.imgLabel}>1001opon</p>
        </div>      
      
      </div>
    </>
  );
};

export default Carousel;